import {
  ChangeContent,
  ClearFilters,
  CloseContent,
  CloseDetails,
  CreateActivitiesBulk,
  CreateActivity,
  DeleteActivity,
  FetchActivityHistory,
  FetchAllActivities,
  FetchAllActivityHistoryFilters,
  OpenContent,
  OpenDetails,
  SelectAllFilters,
  ToggleFilter,
  UpdateActivity,
  UpdateActivityStatus,
} from './actions'
import type { ActivityType } from '../ActivitiyTypes/typings'
import type { ActivityDetails } from '../typings'
import type { FetchAllActivityTypes } from '../ActivitiyTypes/state'

import type { ENTITY_TYPES } from '@sales-center/common'

export type Content = 'list' | 'details' | 'form'

export type ActivityHistoryFilter = {
  id: number
  name: string
  description: string
  isSelected: boolean
}

export type ActivityHistoryFilterCategory = {
  name: string
  filters: ActivityHistoryFilter[]
}

export type ActivityHistoryFilters = {
  statusUpdates: ActivityHistoryFilterCategory
  closingActivities: ActivityHistoryFilterCategory
  customActivities: ActivityHistoryFilterCategory
}

export enum AuditType {
  Create = 1,
  Update,
  Delete,
}

export type AssignmentUpdateDetails = {
  newOwner: string
  newOwnerIsActive?: boolean
  previousOwner: string
  previousOwnerIsActive?: boolean
  automatedAssignmentRule: string
  assignmentUpdatedBy: string
  assignmentUpdatedByIsActive?: boolean
  isFirstAssignment: true
}

export type ActivityHistory = {
  activityHistoryType: string
  statusChange: string
  name: string
  header: string
  description: string
  auditType: AuditType
  auditTypeName: string
  auditTime: Date
  auditByUserName: string
  auditByUserId: string
  auditByUserIsActive: boolean
  isStatusUpdate: boolean
  isClosingActivity: boolean
  isCustomActivity: boolean
  assignmentUpdateDetails: AssignmentUpdateDetails
  entityType: ENTITY_TYPES
  test: string
  agreementUploadedBy: string
}

export type ActivityHistorySearchInput = {
  entityId: number | undefined
  entityType: ENTITY_TYPES | undefined
  showFunnelUpdate: boolean
  showService: boolean
  showAgreement: boolean
  showCardCapture: boolean
  showScheduling: boolean
  showAssignmentUpdate: boolean
  showKnockStatusUpdate: boolean
  activityTypeIds: number[]
}

export type FilterType =
  | 'statusUpdates'
  | 'closingActivities'
  | 'customActivities'

export type State = {
  content: Content
  contentOpened: boolean
  current: number | undefined
  popoverEl: HTMLButtonElement | null
  activities: ActivityDetails[]
  activityTypes: ActivityType[]
  filters: ActivityHistoryFilters
  history: ActivityHistory[]
  filtersChecksum: number | undefined
}

export type Actions =
  | OpenContent
  | CloseContent
  | ChangeContent
  | OpenDetails
  | CloseDetails
  | FetchAllActivities
  | CreateActivity
  | UpdateActivity
  | FetchAllActivityTypes
  | DeleteActivity
  | UpdateActivityStatus
  | FetchAllActivityHistoryFilters
  | FetchActivityHistory
  | ToggleFilter
  | ClearFilters
  | SelectAllFilters
  | CreateActivitiesBulk
